import { NavLink } from "react-router-dom"
import { FaArrowRight } from "react-icons/fa"

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 overflow-hidden relative"
      style={{ backgroundColor: "var(--main-color)" }}
    >
      {/* Orbiting dots */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="relative w-0 h-0">
          <span
            className="absolute w-3 h-3 rounded-full"
            style={{
              backgroundColor: "var(--secondary-color)",
              opacity: 0.6,
              animation: "orbit 8s linear infinite",
            }}
          />
          <span
            className="absolute w-2 h-2 rounded-full"
            style={{
              backgroundColor: "#a5a3ff",
              opacity: 0.4,
              animation: "orbit-reverse 12s linear infinite",
            }}
          />
          <span
            className="absolute w-1.5 h-1.5 rounded-full"
            style={{
              backgroundColor: "var(--secondary-color)",
              opacity: 0.3,
              animation: "orbit 6s linear infinite reverse",
              animationDelay: "-3s",
            }}
          />
        </div>
      </div>

      {/* Glitching 404 */}
      <div
        style={{
          animation: "float-up-down 4s ease-in-out infinite",
        }}
      >
        <h1
          className="glitch-text ubuntu-bold select-none"
          data-text="404"
          style={{
            fontSize: "clamp(120px, 22vw, 220px)",
            lineHeight: 1,
            color: "var(--main-white)",
            letterSpacing: "-4px",
          }}
        >
          404
        </h1>
      </div>

      {/* Divider line */}
      <div
        className="w-24 h-[3px] rounded-full my-8"
        style={{
          backgroundColor: "var(--secondary-color)",
          animation: "fade-in-up 0.6s ease 0.3s both",
        }}
      />

      {/* Message */}
      <div style={{ animation: "fade-in-up 0.6s ease 0.5s both" }}>
        <h2
          className="ubuntu-bold text-[26px] md:text-[34px] text-center mb-4"
          style={{ color: "var(--main-white)" }}
        >
          Page not found
        </h2>
        <p
          className="text-center text-[16px] md:text-[18px] max-w-[420px] mx-auto mb-10"
          style={{ color: "var(--typo)" }}
        >
          The page you're looking for doesn't exist or has been moved. Let's get
          you back on track.
        </p>
      </div>

      {/* CTA */}
      <div style={{ animation: "fade-in-up 0.6s ease 0.7s both" }}>
        <NavLink
          to="/"
          className="btn inline-flex items-center gap-2 text-[16px]"
        >
          Back to home <FaArrowRight className="text-[13px]" />
        </NavLink>
      </div>
    </div>
  )
}
